import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LineChart } from '@mui/x-charts/LineChart';
import { useGetDataChartsMutation } from '../services/home';

export default function YearToYear() {
  const navigate = useNavigate();
  const [getDataCharts, dataCharts] = useGetDataChartsMutation();
  const [dataLoaded, setDataLoaded] = useState({xLabels: [], data: []});

  const margin = { right: 24 };
  const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
  const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
  const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
  ];

  useEffect(() => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    if(user.id != 89)
      navigate('/replenishment');

    getDataCharts({'year': 2025});
  }, []);

  useEffect(() => {
    if(dataCharts.data)
    {
      const dt = JSON.parse(dataCharts.data);
      let channel = [];
      let xLabels = [];
      let data = [];
      dt.map(m=>{
        if(!xLabels.includes(m.MONTH))
          xLabels.push(m.MONTH);
        if(!channel.includes(m.Channel))
          channel.push(m.Channel);
      });
      channel.map(m=>{
        data.push({label: m, data: dt.filter(f=>f.Channel == m).map(c=>c.Amount)});
      })
      
      setDataLoaded({xLabels: xLabels, data: data});
    }
  }, [dataCharts]);

  return (
    <div>
      <LineChart
        height={300}
        series={dataLoaded.data}
        xAxis={[{ scaleType: 'point', data: dataLoaded.xLabels }]}
        yAxis={[{ width: 50 }]}
        margin={margin}
      />
    </div>
  )
}